module.exports = __webpack_public_path__ + "img/kr-product-card3-item3-step3.4f9a83b.png";